export namespace ArrayUtils {
  export function getDistinctArray(arr: string[]) {
    return arr.filter(function(value, index, arr) {
      return arr.indexOf(value) === index;
    });
  }
}



// WEBPACK FOOTER //
// ./utils/ArrayUtils.ts